import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle, ExternalLink } from 'lucide-react';
import { pricingPlans } from '../mock';

const Pagamento = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const enrollmentId = searchParams.get('enrollmentId');
  const planId = searchParams.get('plan');
  const paymentSuccess = searchParams.get('success');

  const selectedPlan = pricingPlans.find(p => p.id === planId);

  const handlePayment = () => {
    const stripeLink = selectedPlan?.stripePaymentLink;
    if (stripeLink) {
      window.location.href = stripeLink;
    } else {
      alert('Errore: piano non valido');
    }
  };

  // Success page
  if (paymentSuccess === 'true') {
    return (
      <div className="payment-success-page">
        <section className="section-spacing">
          <div className="container">
            <Card className="payment-success-card">
              <CardHeader>
                <div className="success-icon-wrapper">
                  <CheckCircle className="success-icon" />
                </div>
                <CardTitle className="heading-2 text-center">Pagamento completato!</CardTitle>
              </CardHeader>
              <CardContent className="payment-success-content">
                <p className="body-medium text-center text-secondary">
                  Grazie per esserti iscritto a StudioInsieme! Riceverai a breve una email di conferma.
                </p>
                <div className="success-actions">
                  <Button onClick={() => navigate('/')} className="btn-primary">
                    Torna alla homepage
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    );
  }

  // Payment page
  return (
    <div className="payment-page">
      <section className="section-spacing">
        <div className="container">
          <div className="section-header">
            <h1 className="heading-1">Completa il pagamento</h1>
            <p className="body-large text-secondary">
              Ultimo passo per completare l'iscrizione
            </p>
          </div>

          <div className="payment-grid">
            <Card className="payment-details-card">
              <CardHeader>
                <CardTitle className="heading-3">Dettagli iscrizione</CardTitle>
              </CardHeader>
              <CardContent>
                {selectedPlan ? (
                  <>
                    <div className="payment-details">
                      <div className="detail-row">
                        <span className="body-medium text-secondary">Piano:</span>
                        <span className="body-medium">{selectedPlan.name}</span>
                      </div>
                      <div className="detail-row detail-row-total">
                        <span className="heading-3">Totale:</span>
                        <span className="heading-3">€{selectedPlan.price}</span>
                      </div>
                    </div>

                    {enrollmentId && (
                      <div className="enrollment-id">
                        <p className="caption text-secondary">ID: {enrollmentId}</p>
                      </div>
                    )}

                    <div className="payment-info">
                      <p className="body-small text-secondary">
                        Pagamento sicuro gestito da Stripe
                      </p>
                      {selectedPlan.requiresCall && (
                        <p className="payment-legal-note">
                          Questo pacchetto viene confermato solo dopo call conoscitiva e proposta personalizzata.
                        </p>
                      )}
                    
                      <p className="payment-legal-note">
                        Prima di pagare leggi <Link to="/termini">termini e condizioni</Link>,{" "}
                        <Link to="/privacy">privacy policy</Link> e{" "}
                        <Link to="/rimborsi">politica rimborsi</Link>.
                      </p>
                    </div>

                    <Button
                      onClick={handlePayment}
                      className="btn-primary w-full"
                    >
                      Vai al pagamento sicuro <ExternalLink className="ml-2 h-4 w-4" />
                    </Button>
                  </>
                ) : (
                  <p className="body-medium">Errore: piano non trovato</p>
                )}
              </CardContent>
            </Card>

            <Card className="payment-features-card">
              <CardHeader>
                <CardTitle className="heading-3">Cosa succede dopo?</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="payment-steps">
                  <div className="payment-step">
                    <div className="step-number-small">1</div>
                    <div>
                      <p className="body-medium">Pagamento su Stripe</p>
                      <p className="body-small text-secondary">Inserisci i dati della carta</p>
                    </div>
                  </div>
                  <div className="payment-step">
                    <div className="step-number-small">2</div>
                    <div>
                      <p className="body-medium">Email di conferma</p>
                      <p className="body-small text-secondary">Riceverai conferma immediata</p>
                    </div>
                  </div>
                  <div className="payment-step">
                    <div className="step-number-small">3</div>
                    <div>
                      <p className="body-medium">Ti contattiamo</p>
                      <p className="body-small text-secondary">Entro 24 ore per iniziare</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pagamento;
